/* Free gift: kept in step with the cart.

   The gift is added alongside the product in product-form.js so both land in one
   request. This file handles the other direction - when the cart stops
   qualifying (the last paid item was removed, or the count dropped below the
   minimum), the cart render marks the gift line and this takes it back out. */

(function () {
  function config() {
    return window.freeGift || null;
  }

  // Reads the eligibility the cart just rendered, so this never has to
  // recompute the rule in two places.
  function removeIfUnqualified() {
    const row = document.querySelector('.cart-item[data-free-gift-remove]');
    if (!row) return;

    const line = parseInt(row.dataset.line, 10);
    const cartItems = row.closest('cart-drawer-items, cart-items');
    if (Number.isNaN(line)) return;
    if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

    // Drop the marker first: updateQuantity re-renders and the fresh markup
    // decides for itself whether the gift still needs removing.
    row.removeAttribute('data-free-gift-remove');
    cartItems.updateQuantity(line, 0, { currentTarget: null });
  }

  document.addEventListener('DOMContentLoaded', removeIfUnqualified);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(removeIfUnqualified, 0));
  }

  // Shared with product-form.js: decide whether this add should carry the gift.
  window.freeGiftItemFor = function freeGiftItemFor(cart, incomingQuantity) {
    const settings = config();
    if (!settings || !settings.enabled || !settings.variantId) return null;

    const items = (cart && cart.items) || [];
    const alreadyThere = items.some(
      (item) => item.properties && item.properties._free_gift
    );
    if (alreadyThere) return null;

    const paid = items.reduce((total, item) => {
      if (item.properties && (item.properties._free_gift || item.properties._gift_wrap)) return total;
      return total + item.quantity;
    }, 0);

    if (paid + (parseInt(incomingQuantity, 10) || 0) < settings.minItems) return null;

    return { id: settings.variantId, quantity: 1, properties: { _free_gift: 'true' } };
  };
})();
